import { roles } from '@/constants'

export default [
  {
    path: '/profile',
    name: 'Profile',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.manager,
        roles.admin
      ]
    },
    component: () => import('../views/profile')
  },
  {
    path: '/',
    name: 'Fields',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.manager,
        roles.admin
      ]
    },
    component: () => import('../views/fields/index')
  },
  {
    path: '/fields/:id',
    name: 'Field',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.manager,
        roles.admin
      ]
    },
    component: () => import('../views/fields/_id')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login')
  },
  {
    path: '/users',
    name: 'Users',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.admin
      ]
    },
    component: () => import('../views/users')
  },
  {
    path: '/user/:id',
    name: 'User',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.admin
      ]
    },
    component: () => import('../views/users/_id')
  },
  {
    path: '/update-user/:id',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.admin
      ]
    },
    component: () => import('../views/users/update')
  },
  {
    path: '/black-list',
    name: 'BlackList',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.admin
      ]
    },
    component: () => import('../views/black-list')
  },
  {
    path: '/create-user',
    name: 'CreateUser',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.admin
      ]
    },
    component: () => import('../views/users/create')
  },
  {
    path: '/create-field',
    name: 'CreateField',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.manager,
        roles.admin
      ]
    },
    component: () => import('../views/fields/create')
  },
  {
    path: '/update-field/:id',
    name: 'UpdateField',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.manager,
        roles.admin
      ]
    },
    component: () => import('../views/fields/update')
  },
  {
    path: '/reports',
    name: 'Reports',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.admin
      ]
    },
    component: () => import('../views/reports')
  },
  {
    path: '/reports/:id',
    name: 'Report',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.admin
      ]
    },
    component: () => import('../views/reports/_id')
  },
  {
    path: '/moderations',
    name: 'Moderations',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.admin
      ]
    },
    component: () => import('../views/moderations')
  },
  {
    path: '/moderations/:id',
    name: 'Moderation',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.admin
      ]
    },
    component: () => import('../views/moderations/_id')
  },
  {
    path: '/events',
    name: 'Events',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.manager,
        roles.admin
      ]
    },
    component: () => import('../views/events/index')
  },
  {
    path: '/events/:id',
    name: 'Event',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.manager,
        roles.admin
      ]
    },
    component: () => import('../views/events/_id')
  },
  {
    path: '/create-event',
    name: 'CreateEvent',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.manager,
        roles.admin
      ]
    },
    component: () => import('../views/events/create')
  },
  {
    path: '/notifications',
    name: 'Notifications',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.admin
      ]
    },
    component: () => import('../views/notifications')
  },
  {
    path: '/team/:id',
    name: 'Team',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.admin
      ]
    },
    component: () => import('../views/team/_id')
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: () => import('../views/forgot')
  },
  {
    path: '/schedule',
    name: 'Schedule',
    meta: {
      layout: 'DefaultLayout',
      roles: [
        roles.manager
      ]
    },
    component: () => import('../views/schedule')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Error404',
    meta: {
      layout: 'DefaultLayout'
    },
    component: () => import('../views/error')
  }
]
